import React from "react";

import type { SideLoadedBusinessGridContext } from "components/Business/SideLoadedBusinesses/useSideLoadedBusinessGridContext";
import type { SideLoadedBusinessRow } from "constants/sideLoadedBusinesses";

interface SideLoadedBusinessIsUsedRendererProps {
  context: SideLoadedBusinessGridContext;
  data?: SideLoadedBusinessRow;
  node: { group: boolean };
}

export function SideLoadedBusinessIsUsedRenderer({
  context,
  data,
  node,
}: SideLoadedBusinessIsUsedRendererProps) {
  const { businessesById } = context;

  if (node?.group || !data) {
    return null;
  }

  const { businessIds } = data.sideLoadedBusiness;

  if (!businessIds.length) {
    return (
      <div title="This SideLoaded business has not yet been mapped to any businesses.">
        No
      </div>
    );
  }

  const businessNames = businessIds
    .map(id => businessesById[id]?.name)
    .filter(Boolean)
    .join(", ");
  // Linked businesses aren't always resolvable locally - not yet synced, or not
  // visible to this user - so say that rather than claiming it's unmapped.
  const title = businessNames
    ? `This SideLoaded business has been mapped to the following businesses: ${businessNames}`
    : "This SideLoaded business has been mapped, but the linked businesses aren't available to view.";
  return <div title={title}>Yes</div>;
}
